import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
// import { Observable } from 'rxjs/Observable';
// import { catchError, map, tap } from 'rxjs/operators';
import { Api } from './../api.module';
import { FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
// import { Observable } from 'rxjs/index';
import * as shajs from 'sha.js';




const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json' //
    // 'auth': 'qwertyuiopasdfghjklzxcvbnm'
  })
};

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  userId: any;
  constructor(private http: HttpClient) { }

  /* getFakeData(){
  return this.http.get(Api.GetAllBlocks)
  .pipe(map((response: any) => response));
 } */

  // getFakeData(): Observable<any> {
  //   return this.http.get<any>(Api.GetAllBlocks);
  // }

  // tslint:disable-next-line: typedef
  logFormSubmit(data) {

    // const body = {
    //   'email': data.email,
    //   'password': data.password
    // };
    // return this.http.post(Api.LOGIN, body).map((response: any) => response);  

    // this.http.get('https://example.com/api/items').pipe(map(data => {})).subscribe(result => {
    //   console.log(result);
    // });
    // return this.http.get(Api.LOGIN, data).pipe(map(data => { }));
    return this.http.post(Api.LOGIN, data).pipe(map((response: any) => response));

  }

  // tslint:disable-next-line: typedef
  changePassword(data) {
    // var cSession4 =   JSON.parse(localStorage.getItem('c_session'));
    // this.userId = cSession4['cSession4'];
    this.userId = localStorage.getItem('loginUserId');
    const body =
    {
      userId: this.userId,
      oldPassword: shajs('sha256').update(data.oldPassword).digest('hex'),//data.oldPassword,
      password: shajs('sha256').update(data.password).digest('hex')//data.password
    };
    return this.http.put(Api.UPDATEUSERSPASSWORD, body).pipe(map((response: any) => response));
  }

  forgetPassword(data) {
    return this.http.post(Api.SAVECHANGEPASSWORDREQUEST, data).pipe(map((response: any) => response));
  }

  // tslint:disable-next-line: typedef
  registrationValue(data) {

    // const body = {
    //   userName: data.userName,
    //   mobile: data.mobile,
    //   email: data.email,
    //   password: data.password,
    //   companyName: data.companyName,
    //   country: { countryId: data.country },
    //   // 'category': { 'categoryId': data.category },
    //   // 'location': { 'locationId': data.location },
    //   userType: { userTypeId: data.userType }
    // };

    // console.log('save user Detail', body);

    return this.http.post(Api.SAVEUSERSDETAIL, data).pipe(map((response: any) => response));
    // return this.http.post(Links.SAVEUSERSDETAIL, body).map((response: any) => response);

  }

  // tslint:disable-next-line: typedef
  resendUserOtp(email) {
    const body = {
      email: email
    };
    console.log(body);
    return this.http.post(Api.RESENDUSEROTP, body).pipe(map((response: any) => response));

  }

  // tslint:disable-next-line: typedef
  optVerification(otpdata, userId) {
    const body = {
      userId: userId,
      otp: otpdata.otp
    };
    console.log('body otp', body);
    // return this.http.post(Api.OTPVERIFICATION, body).map((response: any) => response);
    return this.http.post(Api.OTPVERIFICATION, body).pipe(map((response: any) => response));
  }

  getActiveSubscriptionDetails(): any {
    return this.http.get(Api.GETACTIVESUBSCRIPTIONDETAILS).pipe(map((response: any) => response));
  }

  getActiveSubscriptionList(body): any {
    return this.http.post(Api.GETACTIVESUBSCRIPTIONLIST, body).pipe(map((response: any) => response));
  }

  getSubscriptionPlanAcitvities(): any {
    return this.http.get(Api.GET_SUBSCRIPTION_ACTIVITIES_LIST).pipe(map((response: any) => response));
    // return this.http.post(Api.GET_SUBSCRIPTION_ACTIVITIES_LIST_BY_TYPE, data).pipe(map((response: any) => response));
  }

  post(obj, url) {
    // alert("purchase plan alert 3")
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(obj).forEach(function (param) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", obj[param]);
      mapForm.appendChild(mapInput);
    });
    document.body.appendChild(mapForm);
    mapForm.submit();
  }

  planPurchase(data) {
    // alert("purchase plan alert 2")
    return this.http.post(Api.PAYMENTINITIATE, data).pipe(map((response: any) => response));
  }

  /*
    loggedIn() {
      false;
        if (localStorage.getItem("userDetails")) {
          return true;
        } else {
          return false;
        } 
  
    }*/

  loggedIn() {
    false;
  }

  // New Added
  isLoggednIn() {
    if (localStorage.getItem("c_isLoggedin")) {
      if (localStorage.getItem('isLoggedin') === 'true' || localStorage.getItem("c_isLoggedin") === 'true') {
        return true;
      }
      else {
        return false;
      }
    } else {
      return false;
    }
  }

  pst(body, header) {
    // return this.http.post(Api.OTPVERIFICATION, body).map((response: any) => response);
    return this.http.post("https://vendorinfra.com:8443/vendor-web/paymentInitiate", body, header).pipe(map((response: any) => response));
  }


  getMailCounts() {
    let req = {
      "toId": localStorage.getItem("companyID"),
      "toType": "1"
    }
    console.log("Comp Id:-", req)
    return this.http.post(Api.GET_MAIL_COUNT, req).pipe(map((response: any) => response));
  }

  getPendingMailCount(_fuseNavigationService) {
    this.getMailCounts().subscribe(response => {
      if (response.response == 200) {
        _fuseNavigationService.updateNavigationItem('cmTeam Members', {
          'title': 'Mail',
          'badge': {
            'title': response.object == null ? 0 : response.object,
            'bg': 'rgb(3, 155, 228)',
            'fg': '#FFFFFF'
          }
        });
      }
    });
  }

  getVendorMailCount(){
    let req = {
      "toId": localStorage.getItem("vendorId"),
      "toType":"2"
    }
    console.log("Vendor Id", req);
    return this.http.post(Api.GET_MAIL_COUNT, req).pipe(map((response: any) => response));
   }

  getPendingVendorMailCount(_fuseNavigationService) {
    this.getVendorMailCount().subscribe(response => {
      if (response.response == 200) {
        _fuseNavigationService.updateNavigationItem('vnMail', {
          'title': 'Mail',
          'badge': {
            'title': response.object == null ? 0 : response.object,
            'bg': 'rgb(3, 155, 228)',
            'fg': '#FFFFFF'
          }
        });
      }
    });
  }

}
